import { DefaultTheme } from 'styled-components/macro';
import { common } from './common';

export const payflipDark: DefaultTheme = Object.assign(
  { ...common },
  {
    /* Override theme here */
    // Grayscale palette
    palette_gray_100: '#ffffff',
    palette_gray_80: '#dadae8',
    palette_gray_60: '#a6a6bf',
    palette_gray_40: '#484859',
    palette_gray_10: '#444454',
    palette_gray_5: '#3d3d4c',
    palette_gray_0: '#353542',

    // Primary palette
    palette_primary_125: '#A5274D',
    palette_primary_100: '#D44A74',
    palette_primary_0: '#F7DEE5',

    // White palette
    palette_white: '#2b2b35',

    // Support palette
    palette_success_100: '#D6F3E2',
    palette_success_50: '#008556',
    palette_success_5: '#086343',
    palette_warning_100: '#A64F21',
    palette_warning_50: '#E86825',
    palette_warning_5: '#FFE1BE',
    palette_alert_100: '#9F1B1F',
    palette_alert_50: '#DE1C22',
    palette_alert_5: '#FFD6D7',

    // Cafeteria palette
    palette_blue_100: '#dadae8',
    palette_blue_5: '#444454',
    palette_blue_0: '#3d3d4c',

    // Logo palette
    palette_logo_text: '#ffffff'
  }
);
